export default "__VITE_ASSET__dWnlV$k1__"